import { useState } from 'react';
import { getDataNeta } from '@portal-internet/core';
import Enllac from 'components/corporatiu/Enllac';
import Text from 'components/corporatiu/Text';
import clsx from 'clsx';
import styles from '../itemsresultatcerca.module.scss';

const ItemResultatTransparencia = (props) => {
    const { item } = props;
    const { id, resum, titol, data_publicacio } = item;
    const [resumLlargActive, setResumLlargActive] = useState(false);

    const stylesItem = clsx({
        [styles.itemResultat]: true,
        [styles.itemTransparencia]: true
    });

    const stylesResumText = clsx({
        [styles.resum]: true,
        [styles.resumLlarg]: resumLlargActive
    });

    const route = {
        type: 'web_transparencia_item_document',
        slug: titol,
        id
    };

    const tallarText = (text, longitut) => {
        if (!text || text.length < longitut) return text;
        const nouText = text.substring(0, longitut);
        const ultimEspai = nouText.lastIndexOf(' ');
        let char = nouText[ultimEspai - 1];
        let _end = ultimEspai;
        if (char === ',' || char === ':' || char === '.') {
            _end--;
        }

        return [
            `<span class="entraCurt">${nouText.substring(
                0,
                _end
            )}</span><button class="botoMes">Més</button><span class="entraLlarg">${text.substring(_end)}</span>`
        ];
    };

    const onClickText = ({ target }) => {
        if (target.closest('.botoMes')) {
            setResumLlargActive(true);
        }
    };

    return (
        <article>
            <div className={stylesItem}>
                <Enllac route={route} className={styles.titolItem}>
                    <h3 data-testid='item-resultat-transparencia-titol'>{titol}</h3>
                </Enllac>
                <div className={styles.infoItem}>
                    <Text
                        className={stylesResumText}
                        tag='p'
                        text={`<span data-testid="item-resultat-transparencia-data-publicacio">${getDataNeta(data_publicacio)}</span>${tallarText(resum, 160) || ''}`}
                        onClick={onClickText}
                        dataTestId='item-resultat-transparencia-resum'
                    />
                </div>
            </div>
        </article>
    );
};

export default ItemResultatTransparencia;
